import { render, staticRenderFns } from "./dialogueTranslation.vue?vue&type=template&id=20d41e5e&scoped=true"
import script from "./dialogueTranslation.vue?vue&type=script&lang=js"
export * from "./dialogueTranslation.vue?vue&type=script&lang=js"
import style0 from "./dialogueTranslation.vue?vue&type=style&index=0&id=20d41e5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d41e5e",
  null
  
)

export default component.exports